import { memo } from 'react';
import { View, Image } from 'react-native';
import { AddButton, Panel, Navigation, ActionButton, DataTable } from '../../components';
import { THEME } from '../../../constants/styles';
import * as ASSETS from '../../../constants/assets';

const Actions = memo(function (props) {
  function handleDeletePress() {
    props.onDeletePress(props.item);
  }
  const count = parseInt(props.item?.count);
  return (
    <View style={[THEME.basicRow, { justifyContent: 'center' }]}>
      {/*<ActionButton source={ASSETS.edit} disabled={false} onPress={handleEditPress} />*/}
      <ActionButton
        source={ASSETS.reject}
        disabled={!(props.canEdit && !count)}
        onPress={handleDeletePress}
      />
    </View>
  );
});

export default memo(function (props) {
  function handleSave(val) {
    const valArray = Array.from(
      new Set(
        val
          .split(',')
          .map((name) => {
            return name.trim();
          })
          .filter((name) => !!name)
      )
    );
    props.onSave(valArray);
  }

  function handleAddPress() {
    props.onAddPress?.();
    Navigation.showModal({
      screen: 'BaseSetupAddMultiples',
      title: `Add ${props.title}s`,
      passProps: {
        onSave: handleSave,
        title: props.title,
        placeholderText: props.placeholderText,
      },
    });
  }

  function renderAddButton() {
    if (!props.canEdit) return null;
    return (
      <AddButton
        label="ADD"
        onPress={handleAddPress}
        containerStyle={{ height: 40, paddingRight: 10 }}
        testId={props.title}
      />
    );
  }

  const columnData = [
    {
      headerLabel: 'NAME',
      style: { flex: 1 },
      dataAccessor: 'name',
    },
    {
      headerLabel: () => (
        <Image
          style={{ width: 13, height: 14 }}
          source={require('../../../../resources/staff-icon-small.png')}
        />
      ),
      style: { width: 70 },
      dataAccessor: 'count',
    },
    {
      headerLabel: 'ACTIONS',
      style: { width: 100, borderRightWidth: 0 },
      dataAccessor: (item) => (
        <Actions item={item} onDeletePress={props.onDelete} canEdit={props.canEdit} />
      ),
    },
  ];
  const rowData = props.items?.map((item) => {
    return {
      ...item,
      item,
      key: props.keyFunc?.(item),
    };
  });

  return (
    <Panel
      title={props.title}
      collapsable={props.collapsable}
      containerStyle={props.containerStyle}
      extraHeaderContent={renderAddButton()}
    >
      <View style={[{ height: 300 }, props.panelStyle]}>
        <DataTable columns={columnData} data={rowData} />
      </View>
    </Panel>
  );
});
